import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { openAllowSmsDialog } from 'services/userSlice/userSlice';

function isToday(date: string) {
  const today = moment().startOf('day');
  return moment(date).isAfter(today);
}

export function useAllowNotificationPopupListener() {
  const user = useSelector((state: any) => state.user?.user);

  const shouldSkip = !user || !user.id || user.role === 'admin' || user.sms_notifications_enabled;

  const dispatch = useDispatch();

  const location = useLocation();

  useEffect(() => {
    // localStorage.removeItem('allow_sms_count');
    // localStorage.removeItem('allow_sms_shown_at');

    if (shouldSkip) return;
    if (location.pathname !== '/buyer/bids' && location.pathname !== '/seller/dashboard') return;

    const timesShown = Number(localStorage.getItem('allow_sms_count') || 0);
    const lastShownAt = localStorage.getItem('allow_sms_shown_at');
    if (timesShown > 1) {
      console.log('Showed 2+ times, skipping');
      return;
    }
    if (timesShown === 1 && lastShownAt && isToday(lastShownAt)) {
      console.log('Showed one time today, skipping');
      return;
    }

    localStorage.setItem('allow_sms_count', (timesShown + 1).toString());
    localStorage.setItem('allow_sms_shown_at', moment().toISOString());

    dispatch(openAllowSmsDialog());
  }, [location.pathname]);
}
